import { MapName } from '@addins/core/core';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MapInstanceEventType, MapInstancesService } from '@services/map';
import { filter } from 'rxjs/operators';
import { StatusChangeRequirementsService } from '../../services/status-change-requirements/status-change-requirements.service';
import { StatusListService } from '../../services/status-list/status-list.service';
import { StatusListComponent } from '../status-list/status-list.component';

@Component({
  selector: 'app-status-list-horizontal',
  templateUrl: './status-list-horizontal.component.html',
  styleUrls: ['./status-list-horizontal.component.scss'],
  providers: [StatusListService]
})
export class StatusListHorizontalComponent extends StatusListComponent implements OnInit {
  constructor(
    protected statusListService: StatusListService,
    protected statusChangeRequirementService: StatusChangeRequirementsService,
    protected changeDetectorRef: ChangeDetectorRef,
    private mapInstancesService: MapInstancesService
  ) {
    super(statusListService, statusChangeRequirementService, changeDetectorRef);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected onInit(): void {
    const map = this.mapInstancesService.get(MapName.main);
    super.onInit();

    if (map) {
      map.updateSize();
    } else {
      this._sub = this.mapInstancesService.$change
        .pipe(filter(event => event.name === MapName.main && event.type === MapInstanceEventType.added))
        .subscribe(() => this.onInit());
    }
  }
}
